<template>
  <div class="main" :class="[isVisible ? visible : unvisible]">
    <img src="../assets/page03_person.png" alt="人物" srcset="" class="person">
    <img src="../assets/page03_word.png" alt="button" class="btn-img">
    <div class="loader">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
    <rotate-it />
    
  </div>
</template>

<script>
import Rotate from './Rotate'

export default {
  name: 'Pg3',
  props: ['isVisible'],
  data () {
    return {
      visible: 'visible',
      unvisible: 'unvisible',    
    }
  },
  components: {
    'rotate-it': Rotate
  }
}
</script>

<style type="text/css" scoped>
  .main {
    background-color: #f8f8f8;
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 10;
  }

  .visible {
    display: block;
  }

  .unvisible {
    display: none;
  }

  .person {
    position: absolute;
    left: 13.2vw;
    top: 21.67vw;
    width: 72.5vw;
    animation: zyao2 0.8s infinite;
    
  }
  .btn-img {
    position: absolute;
    bottom: 14.667vw;
    left: 32.67vw;
    width: 35vw;
  }

.loader {
  position: absolute;
  top: 75%;
  left: 40%;
  margin-left: 10%;
  transform: translate3d(-50%, -50%, 0);
}
.dot {
  width: 12px;
  height: 12px;
  background: #3ac;
  border-radius: 100%;
  display: inline-block;
  animation: slide 1s infinite;
}

.dot:nth-child(1) {
  animation-delay: 0.1s;
  background: #ff633b;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
  background: #ff633b;
}
.dot:nth-child(3) {
  animation-delay: 0.3s;
  background: #ff633b;
}
.dot:nth-child(4) {
  animation-delay: 0.4s;
  background: #ff633b;
}
.dot:nth-child(5) {
  animation-delay: 0.5s;
  background: #ff633b;
}

@-moz-keyframes slide {
  0% {
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}
@-webkit-keyframes slide {
  0% {
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}
@-o-keyframes slide {
  0% {
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes slide {
  0% {
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes zyao2{
    0%{transform: rotate(-5deg)}
    50%{transform: rotate(5deg)}
    100%{transform: rotate(-5deg)}
  }
</style>



// WEBPACK FOOTER //
// src/components/Pg3.vue